<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-5">
          <strong class="card-title mb-3">{{'Company Prices Analysis'}} </strong>
        </div>
        <div class="col-md-5"><strong>{{(rawData && rawData.length > 0 )? " Date: "+getFormattedDate(rawData[0].date): ""}}</strong></div>
        <div class="col-md-1">
          <download :tableId="'all-companies'" :fileName="'all-companies-price-analysis'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="table-responsive" v-dragscroll="true">
          <table class="table table-bordered fonts11" id="all-companies">
            <thead>
              <tr class="br">
                <th colspan="6" class="text-center">Historical Data</th>
                <th colspan="9" class="text-center">Decreased Data</th>
              </tr>
              <tr>
                <td
                  class="text-bold"
                  v-for="(tb, ind) in tableFields"
                  v-bind:key="'hist'+ind"
                >{{tb.name}}</td>
                <td
                  class="text-bold"
                  v-for="(tb, indx) in tableDecreasedFields"
                  v-bind:key="'decr'+indx"
                >{{tb.name}}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(comp, index) in rawData" v-bind:key="'comp'+index">
                <td v-for="(tb, ind) in tableFields" v-bind:key="'hist'+ind">
                  <span v-if="tb.title==='co_code'">{{comp[tb.title]}}</span>
                   <span v-else-if="tb.title==='c'">{{comp[tb.title][0]['companyname']}}</span>
                  <span v-else>
                    {{getFixed(comp[tb.title])}}
                    <span v-if="(tb.title === 'min_value' && comp['min_value_date'])">
                      <br>
                      <b>{{getFormattedDate(comp['min_value_date'][0])}}</b>
                    </span>
                    <span v-if="(tb.title === 'max_value' && comp['max_value_date'])">
                      <br>
                      <b>{{getFormattedDate(comp['max_value_date'][0])}}</b>
                    </span>
                  </span>
                </td>
                <td v-for="(tb, indx) in tableDecreasedFields" v-bind:key="'decr'+indx">
                  {{getFixed(comp['decrease_data'][tb.title])}}
                  <span
                    v-if="(tb.title === 'min_value' && comp['decrease_data']['min_value_date'])"
                  >
                    <br>
                   <b>{{getFormattedDate(comp['decrease_data']['min_value_date'][0])}}</b>
                  </span>
                  <span v-if="(tb.title === 'max_value' && comp['decrease_data']['max_value_date'])">
                    <br>
                    <b>{{getFormattedDate(comp['decrease_data']['max_value_date'][0])}}</b>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import spinner from "@/components/spinner";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  // props: ["company"],
  mixins: [commonMixins],
  created() {
    // this.getCompaniesList();
    this.getRawData();
  },
  methods: {
    getRawData() {
      this.rawData = [];
      // this.tableFields = [];
      // this.tableDecreasedFields = [];
      let myself = this;
      http.get(this.rawDataApi, {}, (error, response) => {
        if (response.length > 0) {
          this.rawData = response;
          // console.log(response.decrease_data.data);
          console.log(response);
          if (response.length > 0) {
            // this.tableFields.push({
            //   title: "co_code",
            //   name: this.getLabel("co_code"),
            //   isNumeric: false
            // });
            var tableFields = Object.keys(response[0]);
            // tableFields.forEach((val, key) => {
            //   if (
            //     val !== "co_code" &&
            //     val !== "calc_increase_days" &&
            //     val !== "decrease_data" &&
            //     val.search("date") === -1
            //   ) {
            //     this.tableFields.push({
            //       title: val,
            //       name: this.getLabel(val),
            //       isNumeric: true
            //     });
            //   }
            // });
            var tableFields1 = Object.keys(response[0].decrease_data);
            // tableFields1.forEach((val, key) => {
            //   if (
            //     val !== "calc_increase_days" &&
            //     val !== "decrease_data" &&
            //     val.search("date") === -1
            //   ) {
            //     this.tableDecreasedFields.push({
            //       title: val,
            //       name: this.getLabel(val),
            //       isNumeric: 1
            //     });
            //   }
            // });
          }
          console.log(this.tableDecreasedFields, this.tableFields);
          //TODO:: add company updates into our array in future
        }
      });
    }
  },
  data() {
    return {
      tableFields: [
        { title: "co_code", name: "Company Code" },
        { title: "c", name: "Company" },
        { title: "min_value", name: "Min" },
        { title: "max_value", name: "Max" },
        { title: "avg_value", name: "Avg" },
        { title: "stdev_value", name: "Std Dev" },
        { title: "percentage_variation_", name: "Percent Variation" }
      ],
      rawDataApi: "allCompanyPriceAnalysis",
      rawData: [],
      tableDecreasedFields: [
        { title: "min_value", name: "Min" },
        { title: "max_value", name: "Max" },
        { title: "avg_value", name: "Avg" },
        { title: "min_diff_percentage", name: "Min Diff %" },
        { title: "max_diff_percentage", name: "Max Diff %" },
        { title: "avg_diff_percentage", name: "Avg Diff %" },
        { title: "stdev_value", name: "Std Dev" },
        { title: "percentage_variation_", name: "Percent Variation" }
      ]
    };
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/allCompanyPriceAnalysis.vue